import styles from './Input.module.css';
import type { InputProps } from './types/InputProps';

const Input = ({
  className = '',
  label = '',
  error = false,
  ...props
}: InputProps) => {
  const hasError = Boolean(error);

  return (
    <div
      className={`${styles.inputWrapper} ${hasError ? styles.errorWrapper : ''}`}
    >
      <label>
        <input
          className={`${styles.input} ${className}`}
          {...props}
          placeholder=" "
        />
        {label && <span className={styles.floatingLabel}>{label}</span>}
      </label>
      {typeof error === 'string' && error && (
        <span className={styles.errorMessage}>{error}</span>
      )}
    </div>
  );
};

export default Input;
